import React from "react";
import "./Footer.scss";
const Footer = () => {
  return (
    <div className="footer">
      <a
        href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html"
        target="_blank"
      >
        תנאי שימוש
      </a>
      |
      <a
        href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html"
        target="_blank"
      >
        מדיניות פרטיות
      </a>
      |
      <a href="https://yit.co.il/" target="_blank">
        עיצוב אפיון ופיתוח
        <div className="yit-logo"></div>
      </a>
    </div>
  );
};

export default Footer;
